import {
  actionCreator, API_URL,
  checkHttpStatus, create_post_data, createRequestActionTypes, createSearchUrl, jsonApiHeader,
  showErrorMessage, showSuccessMessage, showWarningMessage,
} from '../../../../../../../actions/utilAction';

export { jsonApiHeader, showWarningMessage, showErrorMessage, actionCreator, checkHttpStatus, create_post_data, createSearchUrl, showSuccessMessage };

export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const POST_PATIENT_GENERAL_SETTINGS_API = `${API_URL}/api/PatientMasterGeneralSettings/SavePatientMasterGeneralSettings`;
export const GET_BEHAVIORREDUCTIONSDATA_API = `${API_URL}/api/PatientBehaviorsReduction/GetPatientBehaviorsReductionByPatientId`;
export const GET_TARGETSANDPROGRAMSDATA_API = `${API_URL}/api/PatientSkillAcquisitionProgram/GetProgramsAndTargetsByPatientId`;
export const POST_DEFAULTPHASECHANGELINE_API = `${API_URL}/api/PatientMasterDefaultPhaseChangeLines/SavePatientMasterDefaultPhaseChangeLines`;
export const GET_DEFAULTPHASECHANGELINES_BYPATIENTID = `${API_URL}/api/PatientMasterDefaultPhaseChangeLines/GetDefaultPhaseChangelinesByPatientId`;
export const GET_DEFAULTPHASECHANGELINESSETTINGS_BYPATIENTID = `${API_URL}/api/PatientMasterDefaultPhaseChangeLines/GetDefaultPhaseChangelinesSettingsByPatientId`;


export const defaultPhaseChangeLinesActionsTypes = {
  get_masterData: createRequestActionTypes('GET_PATIENT_GENERAL_SETTINGS_MASTER_DATA'),
  save_patientGeneralSettings: createRequestActionTypes('SAVE_PATIENT_GENERAL_SETTINGS'),
  get_BehaviorsReductionsData: createRequestActionTypes('GET_BEHAVIORREDUCTIONSDATA'),
  get_TargetsAndProgramsData: createRequestActionTypes('GET_TARGETSANDPROGRAMSDATA'),
  save_DefaultPhaseChangeline: createRequestActionTypes('save_DEFAULTPHASECHANGELINE_API'),
  get_DefaultPhaseChangelinesByPatientId: createRequestActionTypes('GET_DEFAULTPHASECHANGELINES_BYPATIENTID'),
  get_DefaultPhaseChangelinesSettingsByPatientId: createRequestActionTypes('GET_DEFAULTPHASECHANGELINESSETTINGS_BYPATIENTID'),
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SetUp/defaultPhaseChangeLines/constants/ApiConstants.js